export const getCourseImageUrl = (imageField) => {
  if (!imageField) return "";
  if (Array.isArray(imageField)) return imageField[0] || "";
  if (typeof imageField === "string") return imageField;
  return "";
};

const DURATION_UNIT_LABELS = {
  hour: { singular: "Hour", plural: "Hours" },
  hours: { singular: "Hour", plural: "Hours" },
  day: { singular: "Day", plural: "Days" },
  days: { singular: "Day", plural: "Days" },
  week: { singular: "Week", plural: "Weeks" },
  weeks: { singular: "Week", plural: "Weeks" },
  month: { singular: "Month", plural: "Months" },
  months: { singular: "Month", plural: "Months" },
};

const getSingularDurationUnit = (unit = "") => {
  if (!unit) return "";
  const normalized = String(unit).toLowerCase();
  return DURATION_UNIT_LABELS[normalized]
    ? normalized.replace(/s$/, "")
    : normalized;
};

export const formatCourseDuration = (duration) => {
  if (!duration?.value) return "";
  const singularUnit = getSingularDurationUnit(duration.unit);
  const labels = DURATION_UNIT_LABELS[singularUnit];
  if (!labels) {
    return `${duration.value} ${duration.unit || ""}`.trim();
  }

  const numericValue = Number(duration.value);
  const usePlural = !Number.isNaN(numericValue) && numericValue > 1;
  const unitLabel = usePlural ? labels.plural : labels.singular;
  return `${duration.value} ${unitLabel}`;
};
